import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section1 = () => {
  const { t } = useTranslation();

  return (
    <>
      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="mt-14 mb-28 "
      >
        <motion.h1 variants={itemVariants} className=" text-65  text-customYellow mb-3">
          {t("about.section1.title")}
        </motion.h1>
        <motion.p variants={itemVariants} className="text-20 font-light text-customGray">
          {t("about.section1.text")}
        </motion.p>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="h-[50vh]"
      >
        <motion.img
          src="/images/about/about2.jpg"
          className="w-full h-full object-cover object-center"
          initial="initial"
          whileInView="whileInView"
          exit="exit"
          variants={photoVariants}
        />
      </motion.div>
    </>
  );
};

export default Section1;
